<template>
	<div class="app-container">
		<div class="top-bar d-flex justify-content-between px-3 py-2">
			<h3>MeetOrNot?</h3>
			<button class="btn btn-light" @click="switchLocale">{{ $i18n.locale.toUpperCase() }}</button>
		</div>
		<div class="align-items-center justify-content-center min-vh-100 main-div">
			<div v-if="!loading">
				<p style="color:white">{{ $t('instructions') }}</p>
				<b-form @submit.prevent="check" class="mb-5" v-if="!showEmailForm">
					<b-form-group class="labels" :label="$t('meetingReasonLabel')" label-for="meeting-reason">
						<b-form-textarea class="no-resize" id="meeting-reason" v-model="meetingReason"
							required></b-form-textarea>
					</b-form-group>
					<b-button type="submit" variant="primary">{{ $t('check') }}</b-button>
				</b-form>
			</div>
			<div v-if="loading">
				<b-progress :value="progress" :max="loadingMessages.length" animated></b-progress>
				<div class="loading-message">
					<transition name="fade" mode="out-in">
						<div class="labels" :key="currentMessage">{{ currentMessage }}</div>
					</transition>
				</div>
			</div>

			<div v-if="!loading">
				<div v-if="showEmailForm">
					<h2 class="labels">{{ $t('result') }}</h2>
					<b-form>
						<b-form-group class="labels" label-for="email-to" :label="$t('recipientsLabel')">
							<b-form-input id="email-to" type="email" :placeholder="$t('recipients')"></b-form-input>
						</b-form-group>
						<b-form-group class="labels" label-for="email-subject" :label="$t('subjectLabel')">
							<b-form-input id="email-subject" :placeholder="$t('subject')"></b-form-input>
						</b-form-group>
						<b-form-group class="labels" :label="$t('emailLabel')" label-for="email-body">
							<b-form-textarea class="no-resize" id="email-body" :value="meetingReason"
								required></b-form-textarea>
						</b-form-group>
						<b-button variant="success" @click="sendEmail">Ok!</b-button>
					</b-form>
				</div>
			</div>
		</div>
		<div class="about-link-container labels">
			<b-button class="about-button" @click="showAboutModal = true">{{ $t('aboutLabel') }}</b-button>
			<b-modal v-model="showAboutModal" :title="$t('aboutLabel')" hide-footer>
				<p style="text-align: justify;">{{ $t('aboutText') }}</p>
				<a href="https://rrosset.com" target="_blank">{{ $t('aboutLink') }}</a>
			</b-modal>
		</div>
	</div>
</template>

<script>
export default {
	data () {
		return {
			meetingReason: '',
			showEmailForm: false,
			isDarkMode: false,
			showAboutModal: false,
			aboutContent: '',
			loading: false,
			progress: 0,
			currentMessage: '',
		};
	},
	methods: {
		sendEmail () {
			const msg = this.$t( 'msg' );
			alert( msg );
			this.showEmailForm = false;
			this.meetingReason = '';
		},
		switchLocale () {
			this.$i18n.locale = ( this.$i18n.locale === 'en' ) ? 'pt' : 'en';
		},
		async check () {
			this.loadingMessages = this.$t( 'loadingMessages' );
			this.loading = true;
			this.progress = 0;

			for ( const message of this.loadingMessages )
			{
				this.currentMessage = message;
				await new Promise( resolve => setTimeout( resolve, 1500 ) );
				this.progress++;
			}

			this.loading = false;
			this.showEmailForm = true;
		},
	},
};
</script>

<style>
.about-link-container {
	position: fixed;
	bottom: 0;
	left: 50%;
	transform: translateX(-50%);
}

.app-container {
	min-height: 100vh;
	text-align: center;
}

.top-bar {
	background-color: #f8f9fa;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.main-div {
	padding: 100px;
	margin-top: 5rem;
}

.content-container {
	padding-top: 70px;
}

.no-resize {
	resize: none;
}

.top-bar {
	background-color: rgb(53, 53, 53);
	color: white;
}

.labels {
	color: white;
	font-weight: 600;
}

.about-button {
	margin: 1rem;
}
</style>